import { keyBy, isEmpty } from 'lodash-es'
import { createSelector } from 'reselect'

import {
  featureRootSelector
} from 'features/billing/selectors'

const createSubscriptionSelector = createSelector(
  featureRootSelector,
  ({ createSubscription }) => createSubscription
)
export const isLoadedSelector = createSelector(
  createSubscriptionSelector,
  ({ status }) => status && status !== 'initial'
)
export const plansSelector = createSelector(
  createSubscriptionSelector,
  ({ plans }) => plans
)
export const stepSelector = createSelector(
  createSubscriptionSelector,
  ({ step }) => step
)
export const upgradeInProgressSelector = createSelector(
  stepSelector,
  (step) => !!step
)
export const stepOptionsSelector = createSelector(
  createSubscriptionSelector,
  ({ stepOptions }) => stepOptions || {}
)
export const invitationsQuantitySelector = createSelector(
  createSubscriptionSelector,
  ({ invitationsQuantity }) => invitationsQuantity
)
export const dealSelector = createSelector(
  createSubscriptionSelector,
  ({ deal }) => deal
)
export const planIdSelector = createSelector(
  createSubscriptionSelector,
  ({ planId }) => planId
)
const tiersSelector = createSelector(
  createSubscriptionSelector,
  ({ tiers }) => keyBy(tiers, 'id')
)
const selectedTierIdSelector = createSelector(
  createSubscriptionSelector,
  ({ selectedTierId }) => selectedTierId
)
export const selectedTierSelector = createSelector(
  tiersSelector,
  selectedTierIdSelector,
  (tiers, selectedTierId) => tiers && tiers[selectedTierId]
)
export const filteredPlansSelector = createSelector(
  plansSelector,
  selectedTierIdSelector,
  (plans, tier) => plans && plans.filter((plan) => plan.tier === tier)
)
export const onSuccessSelector = createSelector(
  createSubscriptionSelector,
  ({ onSuccess }) => onSuccess
)

export const featureKeySelector = createSelector(
  createSubscriptionSelector,
  ({ featureKey }) => featureKey
)

export const isBasicTierVisibleSelector = createSelector(
  stepOptionsSelector,
  (stepOptions) => !!(stepOptions?.isDowngrading)
)

const checkoutPaymentMethodSelector = createSelector(
  featureRootSelector,
  ({ checkoutPaymentMethod }) => checkoutPaymentMethod || {}
)
export const paymentTokenSelector = createSelector(
  checkoutPaymentMethodSelector,
  ({ token }) => token
)
export const isPaymentTokenLoadingSelector = createSelector(
  checkoutPaymentMethodSelector,
  ({ loading }) => loading
)
export const paypalExpressCheckoutUrlSelector = createSelector(
  checkoutPaymentMethodSelector,
  ({ paypalExpressCheckoutUrl }) => paypalExpressCheckoutUrl
)
export const paymentTokenCreatedSelector = createSelector(
  paymentTokenSelector,
  (token) => !isEmpty(token)
)
const cardSelector = createSelector(
  paymentTokenSelector,
  (token) => (token && token.card) || {}
)
export const zipCodeFromCardSelector = createSelector(
  cardSelector,
  ({ address_zip: zipCode }) => zipCode
)
export const countryFromCardSelector = createSelector(
  cardSelector,
  ({ country }) => country
)
export const stripeFormCompleteSelector = createSelector(
  checkoutPaymentMethodSelector,
  ({ stripeFormComplete }) => stripeFormComplete
)
